import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ThermometerIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M9.13793 0C7.76724 0 6.65517 1.11206 6.65517 2.48276V20.6897C6.65517 22.0604 7.76724 23.1724 9.13793 23.1724C10.5086 23.1724 11.6207 22.0604 11.6207 20.6897V2.48276C11.6207 1.11206 10.5086 0 9.13793 0ZM9.96552 10.6593C9.5 10.6593 9.59518 10.6593 9.13793 10.6593C8.68068 10.6593 9 10.6593 8.31035 10.6593V2.23462C8.31035 1.77736 8.68068 1.40703 9.13793 1.40703C9.59518 1.40703 9.96552 1.77736 9.96552 2.23462V10.6593Z'
                fill='currentColor'
            />
            <Path
                d='M13.2759 19.8621C13.2759 22.1472 11.4231 24 9.13793 24C6.85276 24 5 22.1472 5 19.8621C5 17.5769 6.85276 15.7241 9.13793 15.7241C11.4231 15.7241 13.2759 17.5769 13.2759 19.8621Z'
                fill='currentColor'
            />
            <Path
                d='M16.5862 7.4482C15.5817 7.4482 14.6766 6.84302 14.2927 5.91509C13.9079 4.98819 14.121 3.91956 14.8307 3.20988C15.5403 2.50022 16.6089 2.28711 17.5359 2.67196C18.4638 3.05575 19.069 3.96093 19.069 4.96542C19.069 6.33611 17.9569 7.4482 16.5862 7.4482ZM16.5862 4.13786C16.251 4.13786 15.95 4.33958 15.8217 4.6489C15.6935 4.95822 15.7648 5.31406 16.0007 5.55095C16.2376 5.78681 16.5935 5.85821 16.9028 5.72992C17.2121 5.60164 17.4138 5.30061 17.4138 4.96544C17.4138 4.74613 17.3269 4.5351 17.1717 4.37993C17.0165 4.22476 16.8055 4.13786 16.5862 4.13786Z'
                fill='currentColor'
            />
        </>
    ),
})

ThermometerIcon.displayName = 'ThermometerIcon'
